type IframeState = {
  referrer?: string;
};

const state: IframeState = {};

export const getReferrer = () => {
  return document.referrer ?? state.referrer;
};

export const setReferrer = (referrer: string) => {
  state.referrer = referrer;
};
